import React, { useEffect, useState } from 'react';
import WaiverModal from '../WaiverModal';

interface WaiverSingleItemListProps {
  items: string[];
  label: string;
  fieldLabel: string;
  addButtonLabel: string;
  onChange: (items: string[]) => void;
}

const WaiverSingleItemList: React.FC<WaiverSingleItemListProps> = ({ items, label, fieldLabel, addButtonLabel, onChange }) => {
  const [itemList, setItemList] = useState<string[]>(items || []);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setItemList(items || []);
  }, [items]);

  const addItem = (newItem: { value: string }) => {
    const updatedItems = [...itemList, newItem.value];
    setItemList(updatedItems || []);
    onChange(updatedItems || []);
  };

  const removeItem = (itemToRemove: string) => {
    const updatedItems = itemList.filter(item => item !== itemToRemove);
    setItemList(updatedItems || []);
    onChange(updatedItems || []);
  };

  return (
    <>
      <div className="form-group mini-section">
        <label>{label}:</label>
        <div className="waiver-item-list section-content">
          {(itemList || []).map((item, index) => (
            <div key={index} className="form-control section-item waiver-item">
              <div className="item-content">{item}</div>
              <a onClick={() => removeItem(item)} className="remove-item">X</a>
            </div>
          ))}
          <button className="btn btn-default waiver-button action-button" type="button" onClick={() => setOpen(true)}>
            {addButtonLabel}
          </button>
        </div>
      </div>
      <WaiverModal title={addButtonLabel} onCancel={() => setOpen(false)} isModalOpen={open} fields={[
        { label: fieldLabel, name: 'value', value: '', required: true },
      ]} size={'lg'} submit={(result: any) => {
        addItem(result);
        setOpen(false);
      }} />
    </>
  );
};

export default WaiverSingleItemList;